export function ProfileEmpty({ message }: { message: string }) {
  return (
    <div className='rounded-md border border-dashed border-border p-6 text-center text-sm text-muted-foreground'>
      {message}
    </div>
  )
}
